import { NavLink } from "react-router-dom";
import "./StartPage.css";
import { FrameComponent } from "fmv-component-ui-library";
import { FrameColor } from "@/utils/enums.ts";

export const StartPage = () => {
  return (
    <FrameComponent color={FrameColor.BLUE} headerAlign="left" header="Start">
      <div className="page-container">
        <div className="start-page-text-container">
          <div>
            <h1>Välkommen till vår Kundtjänst – FAQ & Självbetjäning </h1>
            <p>
              Vad roligt att du är här! Vi vill göra det så enkelt som möjligt
              för dig att få hjälp – oavsett om du hittar ditt svar själv eller
              vill kontakta oss direkt.
            </p>
          </div>
        </div>

        <div className="start-page-text-container">
          <div>
            <h2>Sök i vår FAQ – Snabba svar på vanliga frågor</h2>
            <p>
              Börja gärna med att kika i vår{" "}
              <NavLink to="/FAQs">
                <b>FAQ</b>
              </NavLink>
              . Här har vi samlat svar på de vanligaste frågorna.<br></br> Du
              kan enkelt filtrera eller söka för att snabbt hitta det du
              behöver, perfekt om du vill lösa din fråga direkt på egen hand.
            </p>
          </div>
        </div>

        <div className="start-page-text-container">
          <div>
            <h2>Skicka in ett ärende – Vi hjälper dig gärna </h2>
            <p>
              Hittade du inte det du sökte i FAQ? <br></br>Inga problem - vi
              finns här för att hjälpa dig!
            </p>
            <p>
              <b>Så här gör du för att skicka in ett ärende:</b>
            </p>
            <ol>
              <li>
                Klicka på{" "}
                <NavLink to="/skapa-arende">
                  <b>"Skapa ärende"</b>
                </NavLink>
                .
              </li>
              <li>
                Fyll i formuläret – beskriv ditt ärende så tydligt du kan.
              </li>
            </ol>
            <p>
              När vi har börjat hantera ditt ärende får du ett bekräftelsemail
              med ett ärendenummer. Vi ser till att ditt ärende hamnar hos rätt
              person så att du får hjälp så snabbt som möjligt.
            </p>
            <p>
              <b>Behöver du hjälp att skicka in ett ärende?</b>
            </p>
            <p>
              Om du av någon anledning inte kan eller vet hur du ska skicka in
              ett ärende via vår självbetjäningsportal, går det självklart bra
              att mejla oss direkt. <br></br>Kontakta oss gärna via e-post på{" "}
              {""}
              <a href="mailto:verksamhetsstod@fmv.se">
                verksamhetsstod@fmv.se
              </a>{" "}
              eller klicka på kontaktikonen i högra hörnet av sidan.<br></br>{" "}
              Vänligen beskriv ditt ärende så tydligt som möjligt. Vi ser gärna
              ser att du i första hand använder självbetjäningsportalen, det gör
              att vi snabbare kan hantera ditt ärende och se till att det hamnar
              rätt direkt.
            </p>
          </div>
        </div>
        <div className="start-page-text-container">
          <p>
            <b>
              Tveka inte att höra av dig – oavsett fråga. Vår kundtjänst är redo
              att hjälpa dig hela vägen.
            </b>
          </p>
        </div>
      </div>
    </FrameComponent>
  );
};

export default StartPage;
